import BuscaSimplesCards from '@/components/BuscaSimplesCards.vue';

export const mixinMensagemVeto = {
  components: {
    BuscaSimplesCards,
  },
  data() {
    return {
        cardsMensagemVeto: [
            {
              rota: 'PorTipoLegislacaoMensagemVeto',
              icone: require('@/assets/images/icon-tipo-legislacao2.png'),
              iconeClasse: 'legisla-icon',
              titulo: 'Tipo de Legislação',
              descricao: 'Consulte a Mensagem de Veto<br /> por <strong>tipo de legislação</strong>',
            },
            {
              rota: 'PorTipoVetoMensagemVeto',
              icone: require('@/assets/images/icon-tipo-veto2.png'),
              iconeClasse: 'legisla-icon',
              titulo: 'Tipo de Veto',
              descricao: 'Consulte a Mensagem de Veto<br /> por <strong>tipo de veto</strong>',
            },
            {
              rota: 'PorAnoMensagemVeto',
              icone: require('@/assets/images/icon-indice-cronologico2.png'),
              iconeClasse: 'indice-icon',
              titulo: 'Índice Cronológico',
              descricao: 'Consulte a Mensagem de Veto<br /> por <strong>ano</strong>',
            },
          ],
    };
  },
};